/**
 * work-warehouse-sources list → 退料左欄物料群組。
 *
 * @param {array} rows camelCase sources（sourceType／id／stockNo／mtr／location／unit／availableQty）
 * @param {object|null} warehouse 回傳頂層 warehouse（location 可 null）
 * @returns {{ materials: array }}
 */
export function normalizeReturnWorkWarehouseSources(rows = [], warehouse = null) {
  const order = [];
  const map = new Map();
  const warehouseLabel = formatWarehouseLabel(warehouse);

  (rows ?? []).forEach((row) => {
    const mtrId = row?.mtr?.id;
    if (!mtrId) {
      return;
    }

    const availableQty = Number(row.availableQty);
    const qty = Number.isFinite(availableQty) ? availableQty : 0;
    if (qty <= 0) {
      return;
    }

    const sourceType = row.sourceType || 'INVENTORY_STOCK';
    // 待分配來源可退（261021）：送 pending_allocation_id，一般庫存送 inv_stock_id。
    const selectable = sourceType === 'INVENTORY_STOCK'
      || sourceType === 'PENDING_ALLOCATION';

    if (!map.has(mtrId)) {
      map.set(mtrId, {
        mtrId,
        mtrNo: row.mtr?.mtrNo ?? '',
        mtrName: row.mtr?.name ?? '',
        onHandQty: 0,
        sources: [],
      });
      order.push(mtrId);
    }

    const group = map.get(mtrId);
    if (selectable) {
      group.onHandQty += qty;
    }

    group.sources.push({
      id: row.id,
      stockNo: row.stockNo ?? '',
      sourceType,
      selectable,
      warehouseLabel,
      locationLabel: formatLocationLabel(row.location),
      unitLabel: formatUnitLabel(row.unit),
      availableQty: qty,
    });
  });

  return {
    materials: order
      .map((mtrId) => map.get(mtrId))
      .filter((group) => group.sources.length > 0),
  };
}

/** @deprecated 請改用 {@link normalizeReturnWorkWarehouseSources} */
export function normalizeReturnInventory(rows = []) {
  return normalizeReturnWorkWarehouseSources(rows, null);
}

function formatWarehouseLabel(warehouse) {
  if (!warehouse) {
    return '';
  }
  return [warehouse.code, warehouse.name].filter(Boolean).join(' ') || warehouse.name || '';
}

function formatLocationLabel(location) {
  if (!location) {
    return '';
  }
  return [location.code, location.name].filter(Boolean).join(' ') || location.name || '';
}

function formatUnitLabel(unit) {
  if (!unit) {
    return '';
  }
  return unit.code || unit.name || '';
}
